app.ui.registerUi('checkboxRadio', function(app) {
	var helpers = app.helpers.funcs;
    return {
        implementationExists: function () {
            return true; // Implements
        },
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
        init: function ($scope) {
            if (!this.implementationExists()) return;
            var scope = this;
            var $checkboxes = helpers.resolveScope('input.custom-checkbox-radio-seed', $scope);
            $checkboxes.blur(function () {
                $checkboxes.closest('div').removeClass('focus');
            });
            $checkboxes.focus(function () {
                $(this).closest('div').addClass('focus');
            });
            $checkboxes.each(function (k, checkbox) {
                var $checkbox = $(checkbox);
                var wrapperClass = ($checkbox.attr('type') == 'checkbox') ? 'custom-checkbox' : 'custom-radio';
                $checkbox.wrap('<div class="' + wrapperClass + '"></div>');
                scope.updateWrap($checkbox, false);
                //Since we are using custom checkboxes, the div is what is being clicked on. This event also gets triggered via clicking the label and tabbing to the checkbox then pressing spacebar, so we use the if statement to check for only clicks on the div itself.
                $checkbox.parent().on('click', function(e) {
                    if ($checkbox.prop('disabled')) return;
                    if (e.originalEvent.detail !== 0) {
                        $checkbox.prop('checked', !$checkbox.prop('checked'));
                        $checkbox.trigger('change');
                    }
                });
                //This will be triggered by clicking on the label or tabbing to the checkbox then pressing spacebar, or manually as above.
                $checkbox.on('change', function (e) {
                    var $wrapper = $checkbox.closest('div');
                    scope.updateWrap($checkbox);
                    if ((!$wrapper.hasClass('unchecking')) && (!$checkbox.prop('checked'))) {
                        $wrapper.addClass('unchecking');
                        setTimeout(function () {
                            $wrapper.removeClass('unchecking');
                        }, 250);
                    }
                });
            });
        },
        updateWrap: function ($checkbox, clearItems) {
            clearItems = typeof clearItems !== 'undefined' ? !!clearItems : true;
            var $wrapper = $checkbox.closest('div');
            var name = $checkbox.attr('name');
            var checked = false;
            var $groupElems = $('input[name=' + name + ']');
            var $wrappers = $groupElems.closest('div');
            if ($checkbox.attr('type') == 'checkbox') {
                checked = $checkbox.prop('checked');
            } else if ($checkbox.attr('type') == 'radio') {
                var groupVal = $('input[name=' + name + ']:checked').val();
                var thisVal = $checkbox.attr('value');
                checked = thisVal == groupVal;
            }
            if (clearItems) $wrappers.removeClass('checked');
            if (checked) {
                $wrapper.addClass('checked');
            }
        }
	};
});